import React from 'react';
import { AppProvider, useApp } from './contexts/AppContext';
import MainDashboard from './components/MainDashboard';
import ErrorBoundary from './components/ErrorBoundary';
import LoadingOverlay from './components/LoadingOverlay';
import './index.css';

const AppContent: React.FC = () => {
  const { isLoading, loadingMessage } = useApp();
  
  return (
    <>
      <LoadingOverlay isLoading={isLoading} message={loadingMessage} />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
        <MainDashboard />
      </div>
    </>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <AppProvider>
        <AppContent />
      </AppProvider>
    </ErrorBoundary>
  );
}

export default App;
// Force recompile
